const SETTINGS = {
  GENERAL: 'general',
  EXERCISES: 'exercises',
  TEACHERS: 'teachers',
  EXTENDED: 'extended',
  SHEETS: 'sheets'
};

export default SETTINGS;
